<div fxLayoutAlign="center center"><h2>Personal Information</h2></div>
<div fxLayoutAlign="center center">
    <div fxLayout="column" fxFlex="40" fxFlex.md="50" fxFlex.sm="80" fxFlex.xs="95">
        <form [formGroup]="personalInfoForm"  autocomplete="off">
            <div fxLayout="column" fxLayoutGap="10px">
                <div>
                    <div fxLayout="row">
                        <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Initials</mat-label></div>
                        <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                            <mat-label fxHide.gt-xs>Initials</mat-label>
                            <input [(value)]="personalInfo.initials" matInput  (change)="personalInfo.initials = $event.target.value" placeholder="Enter initials" formControlName="initialsControl">
                            <mat-error *ngIf="initialsControl.hasError('required')">Initials are required!</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <div fxLayout="row">
                        <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Surname</mat-label></div>
                        <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                            <mat-label fxHide.gt-xs>Surname</mat-label>
                            <input [(value)]="personalInfo.surname" matInput  (change)="personalInfo.surname = $event.target.value" placeholder="Enter surname" formControlName="surnameControl">
                            <mat-error *ngIf="surnameControl.hasError('required')">Surname is required!</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <div fxLayout="row">
                        <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Email</mat-label></div>
                        <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                            <mat-label fxHide.gt-xs>Email</mat-label>
                            <input [(value)]="personalInfo.email" matInput  (change)="personalInfo.email = $event.target.value" placeholder="Enter email address" formControlName="emailAddressControl">
                            <mat-error *ngIf="emailAddressControl.hasError('required')">Email is required!</mat-error>
                            <mat-error *ngIf="!emailAddressControl.hasError('required') && emailAddressControl.hasError('email')">Invalid email address!</mat-error>
                            <mat-error *ngIf="!emailAddressControl.hasError('required') && !emailAddressControl.hasError('email') && emailAddressControl.hasError('emailMismatch')">Email and confirm email do not match!</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div>
                    <div fxLayout="row">
                        <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Confirm Email</mat-label></div>
                        <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                            <mat-label fxHide.gt-xs>Confirm Email</mat-label>
                            <input [(value)]="confirmEmail" matInput (change)="confirmEmail = $event.target.value" placeholder="Confirm email address" [type]="hideConfirmEmail ? 'password' : 'text'" formControlName="confirmEmailControl">
                            <mat-icon matSuffix class="confirm-email-icon" (mousedown)="confirmEmailVisible()" (mouseup)="confirmEmailHidden()" (mouseleave)="confirmEmailHidden()">{{hideConfirmEmail ? 'visibility_off' : 'visibility'}}</mat-icon>
                            <mat-error *ngIf="confirmEmailControl.hasError('required')">Confirm email is required!</mat-error>
                            <mat-error *ngIf="!confirmEmailControl.hasError('required') && confirmEmailControl.hasError('email')">Invalid email address!</mat-error>
                            <mat-error *ngIf="!confirmEmailControl.hasError('required') && !confirmEmailControl.hasError('email') && confirmEmailControl.hasError('emailMismatch')">Email and confirm email do not match!</mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <button mat-button fxHide id="btnPersonaInfo"></button>
        </form>

        <div class="container-group-spacing">
            <mat-checkbox [checked]="sendEmail" (change)="sendEmail = !sendEmail">Send copy of document(s) to my email address</mat-checkbox>
        </div>
        <div class="container-group-spacing">
            <mat-checkbox [checked]="generateQuotation" (change)="generateQuotation = !generateQuotation">Generate Quotation?</mat-checkbox>
        </div>
        <div class="container-group-spacing expansion-panel-checkbox-container">
            <mat-checkbox [checked]="generateProforma" (change)="generateProforma = !generateProforma">Generate Pro-forma invoice?</mat-checkbox>
        </div>
        <form [formGroup]="proformaForm" autocomplete="off">
            <mat-expansion-panel [expanded]="generateProforma" class="mat-elevation-z0">
                <div fxLayout="column" fxLayoutGap="10px">
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Funder Name</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Funder Name</mat-label>
                                <input [(value)]="proformaInfo.companyName" matInput  (change)="proformaInfo.companyName = $event.target.value" placeholder="Enter funder name" formControlName="companyNameControl">
                                <mat-error *ngIf="companyNameControl.hasError('required')">Funder name is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Contact Person</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Contact Person</mat-label>
                                <input [(value)]="proformaInfo.contactPerson" matInput  (change)="proformaInfo.contactPerson = $event.target.value" placeholder="Enter contact person" formControlName="contactPersonControl">
                                <mat-error *ngIf="contactPersonControl.hasError('required')">Contact person is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Contact Number</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Contact Number</mat-label>
                                <input [(value)]="proformaInfo.contactNumber" matInput  (change)="proformaInfo.contactNumber = $event.target.value" placeholder="Enter contact number" formControlName="contactNumberControl">
                                <mat-error *ngIf="contactNumberControl.hasError('required')">Contact number is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Registration Number</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Registration Number</mat-label>
                                <input [(value)]="proformaInfo.companyRegNumber" matInput  (change)="proformaInfo.companyRegNumber = $event.target.value" placeholder="Enter registration number" formControlName="companyRegNumberControl">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>VAT Number</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>VAT Number</mat-label>
                                <input [(value)]="proformaInfo.vatNumber" matInput  (change)="proformaInfo.vatNumber = $event.target.value" placeholder="Enter VAT number" formControlName="vatNumberControl">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Address Line 1</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Address Line 1</mat-label>
                                <input [(value)]="proformaInfo.addressLine1" matInput  (change)="proformaInfo.addressLine1 = $event.target.value" placeholder="Enter address line 1" formControlName="addressLine1Control">
                                <mat-error *ngIf="addressLine1Control.hasError('required')">Address line 1 is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Address Line 2</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Address Line 2</mat-label>
                                <input [(value)]="proformaInfo.addressLine2" matInput  (change)="proformaInfo.addressLine2 = $event.target.value" placeholder="Enter address line 2" formControlName="addressLine2Control">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>City/Suburb</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>City/Suburb</mat-label>
                                <input [(value)]="proformaInfo.city" matInput  (change)="proformaInfo.city = $event.target.value" placeholder="Enter city/suburb" formControlName="cityControl">
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Postal Code</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Postal Code</mat-label>
                                <input [(value)]="proformaInfo.postalCode" matInput  (change)="proformaInfo.postalCode = $event.target.value" placeholder="Enter postalCode" formControlName="postalCodeControl">
                                <mat-error *ngIf="postalCodeControl.hasError('required')">Postal code is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div>
                        <div fxLayout="row">
                            <div fxHide.xs fxLayoutAlign="start center" class="mat-label-box"><mat-label>Country</mat-label></div>
                            <mat-form-field fxFlex appearance="fill" [floatLabel]="labelFloat">
                                <mat-label fxHide.gt-xs>Country</mat-label>
                                <input [(value)]="proformaInfo.country" matInput  (change)="proformaInfo.country = $event.target.value" placeholder="Enter country" formControlName="countryControl">
                                <mat-error *ngIf="countryControl.hasError('required')">Country is required!</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <button mat-button fxHide id="btnProformaInvoice"></button>
            </mat-expansion-panel>
        </form>
        <div fxFlex="row" class="navigation-container">
            <div fxFlex="50" fxLayoutAlign="start center">
                <button mat-button [routerLink]="['/default', {outlets: {'main': ['summary']}}]" class="navigation-button navigation-button-back">Back</button>
            </div>
            <div fxFlex="50" fxLayoutAlign="end center">
                <button mat-button (click)="generateReport()" class="navigation-button navigation-button-proceed">Generate</button>
            </div>
        </div>
    </div>
</div>